// True when the given hostname is a local/loopback address. The SDK must not
// send metrics from localhost — the fallback siteId would be this hostname,
// which is never a registered, trackable site.
export function isLocalHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return (
    host === "localhost" ||
    host.endsWith(".localhost") ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host === "::1" ||
    host === "[::1]"
  );
}
